WL.registerComponent('physx-shot-receiver', {
}, {
    init: function() {
      this.callbacks = [];  
    },
    addCallback: function(cb) {
        this.callbacks.push(cb);
    },
    removeCallback: function(cb) {
        let index = this.callbacks.indexOf(cb)
        if(index !== -1) {
            this.callbacks.splice(index, 1);
        }
    },
    removeAllCallbacks: function() {
      this.callbacks = [];  
    },
    onShot: function() {
        for (let i = 0; i < this.callbacks.length; i++) {
            this.callbacks[i]();
        }
    },
});
